import { Snackbar, SnackbarContent } from "@mui/material";

export const NotificationSnackbar = ({ handleOpen, onClose, message }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={handleOpen}
      autoHideDuration={6000}
      onClose={onClose}
    >
      <SnackbarContent
        sx={{ backgroundColor: "#0099d8" }}
        message={<span id="client-snackbar">{message}</span>}
      />
    </Snackbar>
  );
};
